import { StrictMode } from "react";
import { CookiesProvider } from "react-cookie";
import { createRoot } from "react-dom/client";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import "regenerator-runtime/runtime.js"; // Он нужен для recaptcha
import { appConstants } from "./appConstants";
import { AppRouterProvider } from "./router/AppRouterProvider";
import { store } from "./store/store";
import { env } from "~/env";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <HelmetProvider>
          <Helmet titleTemplate={`%s - ${appConstants.mfoNameShort}`}>
            <meta name="description" content={env.VITE_MFO_NAME_LONG} />
          </Helmet>
          <AppRouterProvider />
        </HelmetProvider>
      </Provider>
    </CookiesProvider>
  </StrictMode>
);
